import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'

import FormatCheckTextBox from '../../../common/component/FormatCheckTextBox'
import Window from '../../../common/Window'

class CommaonPasswordReset extends Component {
  constructor (props) {
    super(props)
    this.state = {email: '', verificationCode: '', newPassword: '', isWatingVerificationCode: false}
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  sendVerificationCode (e) {
    e.preventDefault()
    const username = this.state.email.trim()
    if (username === '') {
      Window.alert('メールアドレスは必須です')
      return false
    }
    const onSuccess = (result) => {
      // console.log('call result: ' + result)
    }
    const onFailure = (err) => {
      switch (err.code) {
        case 'LimitExceededException':
          Window.alert('認証コード送信回数の上限に達しました。\nしばらくたってから再度お試しください。')
          break
        default:
          Window.alert('認証コードの送信に失敗しました')
          // console.log(err.code)
          break
      }
    }
    const inputVerificationCode = (cognitoUser, onSuccess, onFailure) => {
      this.setState({
        isWatingVerificationCode: true
      })
    }
    AWSAPI.forgotPassword(this.userRole, username, onSuccess, onFailure, inputVerificationCode)
  }
  validate (newPassword, verificationCode) {
    const requiredErrors = []
    if (newPassword === '') {
      requiredErrors.push('新しいパスワード')
    }
    if (verificationCode === '') {
      requiredErrors.push('認証コード')
    }
    if (requiredErrors.length > 0) {
      Window.alert(requiredErrors.join('、') + 'は必須です')
      return false
    }
    if (newPassword.length < 8 || !newPassword.match(/^[a-z\d!#_&@]{8,256}$/i)) {
      Window.alert('パスワードは英数字か次の半角記号（!#_&@）の組み合わせ8文字以上で入力してください')
      return false
    }
    return true
  }
  changePassword (e) {
    e.preventDefault()
    const onSuccess = (result) => {
      Window.alert('パスワードを変更しました。', () => {
        this.props.history.push('/' + this.userRoleUrl + '/login')
        Window.closeDialog()
      })
    }
    const onFailure = (err) => {
      switch (err.code) {
        case 'CodeMismatchException':
          Window.alert('認証コードが正しくありません')
          break
        default:
          Window.alert('パスワードの更新に失敗しました')
          console.log(err.code)
          break
      }
    }
    const username = this.state.email.trim()
    const verificationCode = this.state.verificationCode.trim()
    const newPassword = this.state.newPassword
    if (!this.validate(newPassword, verificationCode)) {
      return false
    }
    AWSAPI.confirmPassword(this.userRole, username, verificationCode, newPassword, onSuccess, onFailure)
  }
  cancel () {
    this.props.history.push('/' + this.userRoleUrl + '/login')
  }
  renderInputEmailForm () {
    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
    return (
      <div id='body-container'>
        <div id='body-content'>
          <div className='container'>
            <div className='signin-row'>
              <div className='logo'><img src='/images/logo.png' alt='ロゴ' /><span>{this.passwordResetFormTitle}</span></div>
              <div className='well well-small well-shadow'>
                <legend>パスワードの再設定</legend>
                <p>パスワードの再設定を行いたいメールアドレスを入力し「認証コードを送信する」ボタンを押してください。</p>
                <form method='POST' className='form-signin' autoComplete='off' onSubmit={e => this.sendVerificationCode(e)}>
                  <div className='input-prepend'>
                    <span className='add-on' rel='tooltip' title='E-Mail Address' data-placement='top'><i className='icon-envelope' />Ｅメール</span>
                    <FormatCheckTextBox className='span5' value={this.state.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
                    <br />
                    <br />
                    <p>info@nikkendaikyou.netからのメールの受信許可をお願いします。<br />※キャリアメールの方は各社サイトで設定をご確認ください。</p>
                  </div>
                  <footer className='signin-actions'>
                    <button className='btn btn-primary' onClick={e => this.sendVerificationCode(e)}>認証コードを送信する</button>&nbsp;&nbsp;
                    <button className='btn btn-default' onClick={e => this.cancel(e)}>キャンセル</button>
                  </footer>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  renderInputVerificationCodeAndNewPassword () {
    const verificationCodePattern = /^[\d]{6,10}$/i
    const passwordPattern = /^[a-z\d!#_&@]{8,256}$/i
    return (
      <div id='body-container'>
        <div id='body-content'>
          <div className='container'>
            <div className='signin-row'>
              <div className='logo'><img src='/images/logo.png' alt='ロゴ' /><span>日本型枠工事業協会</span></div>
              <div className='well well-small well-shadow'>
                <legend>パスワードの再設定</legend>
                <p>入力されたメールアドレスにパスワード再設定用の認証コードを</p>
                <p>
                  <em>{this.state.email}</em>
                </p>
                <p>宛に送信いたしました。</p>
                <p>送付された認証コードと新しく設定したいパスワードを入力して「パスワードを再設定する」ボタンを押してください。</p>
                <form method='POST' className='form-signin' autoComplete='off' onSubmit={e => this.changePassword(e)}>
                  <div className='input-prepend'>
                    <span className='add-on'><i className='icon-key' />認証コード</span>
                    <FormatCheckTextBox type='password' className='span4' value={this.state.verificationCode} autoComplete='false' onChange={e => this.changed('verificationCode', e)} pattern={verificationCodePattern} placeholder='認証コード' message='正しい形式で認証コードを入力してください' />
                  </div>
                  <div className='input-prepend'>
                    <span className='add-on'><i className='icon-key' />パスワード</span>
                    <FormatCheckTextBox type='password' className='span4' value={this.state.newPassword} autoComplete='false' onChange={e => this.changed('newPassword', e)} pattern={passwordPattern} placeholder='8文字以上' message='パスワードは英数字か次の半角記号（!#_&@）の組み合わせ8文字以上で入力してください' />
                  </div>
                  <footer className='signin-actions'>
                    <button className='btn btn-primary btn-l' onClick={e => this.changePassword(e)}>パスワードを再設定する</button>
                  </footer>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  render () {
    let view = null
    if (this.state.isWatingVerificationCode) {
      view = this.renderInputVerificationCodeAndNewPassword()
    } else {
      view = this.renderInputEmailForm()
    }
    return view
  }
}

export default CommaonPasswordReset



// WEBPACK FOOTER //
// ./src/common/pages/public/PasswordReset.js